// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';

$(() => {
  // リストに追加するを押下した場合
  if ($('button[name="photo_add_list"]').length) {
    $('button[name="photo_add_list"]').on('click', (e) => {
      const photoId = e.target.id.replace('add_list_', '');
      $(`#add_list_${photoId}`).addClass('d-none');
      $(`#remove_list_${photoId}`).removeClass('d-none');

      // 新規登録;
      $.ajax({
        url: `/hq/photo_dl_selections`,
        beforeSend(xhr) {
          xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
        },
        type: 'POST',
        dataType: 'json',
        data: { photo_id: photoId },
        timeout: 3000,
      }).fail(function fail() {
        $(`#add_list_${photoId}`).removeClass('d-none');
        $(`#remove_list_${photoId}`).addClass('d-none');
      });
    });
  }

  // リストに追加済を押下した場合
  $('button[name="photo_remove_list"]').on('click', (e) => {
    const photoId = e.target.id.replace('remove_list_', '');
    $(`#add_list_${photoId}`).removeClass('d-none');
    $(`#remove_list_${photoId}`).addClass('d-none');

    $.ajax({
      url: `/hq/photo_dl_selections/${photoId}`,
      beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
      },
      type: 'DELETE',
      dataType: 'json',
      timeout: 3000,
    }).fail(function fail() {
      $(`#add_list_${photoId}`).removeClass('d-none');
      $(`#remove_list_${photoId}`).addClass('d-none');
    });
  });

  function isActivationBulkDownload() {
    // 利用規約チェックボックス
    // On:  ダウンロードボタンを活性化
    // Off: ダウンロードボタンを非活性
    return $('#photo_terms_of_use').prop('checked');
  }

  function setBulkDownloadDisabled() {
    $('#bulk_download').prop('disabled', !isActivationBulkDownload());
  }

  // 利用規約のチェックボックスを変更された場合
  $('#photo_terms_of_use').change(() => {
    setBulkDownloadDisabled();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const photoModalDisplay = document.getElementById('photo-modal');

  if (photoModalDisplay) {
    const descriptionButtons = document.querySelectorAll('[data-photo-modal-button-id]');
    const modalContents = document.querySelectorAll('[data-photo-modal-content-id]');

    descriptionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.getAttribute('data-photo-modal-button-id');

        const targetModalTemplate = Array.from(modalContents).find((modal) => {
          return modal.getAttribute('data-photo-modal-content-id') === id;
        });

        const modalContent = targetModalTemplate.content;

        const clone = document.importNode(modalContent, true);

        photoModalDisplay.innerHTML = '';
        photoModalDisplay.appendChild(clone);

        photoModalDisplay.classList.add('active');

        const closeButton = photoModalDisplay.querySelector('[data-action="close"]');
        if (closeButton) {
          closeButton.addEventListener('click', () => {
            photoModalDisplay.classList.remove('active');
            photoModalDisplay.innerHTML = '';
          });
        }
      });
    });
  }
});
